var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fx-label-container",style:({minWidth: _vm.width,width: _vm.width,bold: _vm.error,color: _vm.error ? 'red' : null})},[_vm._v(" "+_vm._s(_vm.text)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }